import "@babel/polyfill";
import Vue from "vue";
import VueMaterial from "vue-material";
import "vue-material/dist/vue-material.min.css";
import "vue-material/dist/theme/default-dark.css";
import App from "./App.vue";
import router from "./router";
import BootstrapVue from "bootstrap-vue";
import store from "./store";
import { makeMulinoAPI } from "./services/mulino-api.service";
import { makeCommunityAPI } from "./services/community-api.service";
import { makeMeetupAPI } from "./services/meetup-api.service";
import { makeEventsAPI } from "./services/cm-event-api.service";
import { makeReservationAPI } from "./services/cm-reservation-api.service";
import { makeChallengeAPI } from "./services/cm-challenge-api.service";
import { makeWorkAPI } from "./services/cm-forwork-api.service";
import { makeCfpAPI } from "./services/cm-cfp-api.service";
import { makePapersAPI } from "./services/cm-paper-api-service";
import { _retrieveToken } from "./services/api.service";
import VueQrcode from '@chenfengyuan/vue-qrcode';
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'
import Croppa from 'vue-croppa';
import 'vue-croppa/dist/vue-croppa.css'
import VueSimplemde from 'vue-simplemde'
import 'simplemde/dist/simplemde.min.css'
import VueScrollTo from "vue-scrollto"
import { Chrome } from 'vue-color'
import vueDebounce from "vue-debounce";
import { makeHackathonAPI } from './services/hackathon.service';

Vue.component('chrome-picker', Chrome)

Vue.component("vue-simplemde", VueSimplemde);

Vue.component("VueSlider", VueSlider);

Vue.component(VueQrcode.name, VueQrcode);

Vue.config.productionTip = false;
Vue.use(vueDebounce);
Vue.use(VueMaterial);
Vue.use(BootstrapVue);
Vue.use(Croppa);
Vue.use(VueScrollTo);

const token = _retrieveToken();

const mulinoApi = makeMulinoAPI(token, store);
const cfpApi = makeCfpAPI(token, store);
const communityApi = makeCommunityAPI(token, store);
const meetupApi = makeMeetupAPI(token, store);
const eventsApi = makeEventsAPI(token, store);
const workApi = makeWorkAPI(token, store);
const reservationApi = makeReservationAPI(token, store);
const challengeApi = makeChallengeAPI(token, store);
const papersApi = makePapersAPI(token, store);
const hackathonApi = makeHackathonAPI(token, store);

new Vue({
    router,
    render: h => h(App),
    MulinoAPI: mulinoApi,
    CommunityAPI: communityApi,
    MeetupAPI: meetupApi,
    EventsAPI: eventsApi,
    ReservationAPI: reservationApi,
    ChallengeAPI: challengeApi,
    CfpAPI: cfpApi,
    PapersAPI: papersApi,
    HackathonAPI: hackathonApi,
    WorkAPI: workApi,
    store
}).$mount("#app");
